interface IntroContentProps {
	messageType: 'email' | 'SMS' | 'short';
	sendCodeTo: string;
	isYachtsMode?: boolean;
	isUserPersistent?: boolean;
	registerLink?: string;
}

export default function getIntroContent({
	messageType, // 'email' | 'SMS' | 'short'
	sendCodeTo,
	isYachtsMode = false,
	isUserPersistent = false,
	registerLink = '/register',
}: IntroContentProps) {
	if (messageType === 'short') {
		return {
			translationKey: `Please enter the 6-digit code we sent to <strong>{0}</strong>`,
			translationParams: [sendCodeTo],
		};
	}

	if (isYachtsMode && messageType === 'email') {
		return {
			translationKey: `An ${messageType} with a 6-digit code was sent to <strong>{0}</strong>. If you did not receive a code, check your spam folder or contact your Personal Yacht Consultant for help.`,
			translationParams: [sendCodeTo],
		};
	}

	if (isYachtsMode && messageType === 'SMS') {
		return {
			translationKey: `An ${messageType} with a 6-digit code was sent to <strong>{0}</strong>. If you did not receive a code, contact your Personal Yacht Consultant for help.`,
			translationParams: [sendCodeTo],
		};
	}

	if (isUserPersistent) {
		return {
			translationKey: `An ${messageType} with a 6-digit code was sent to <strong>{0}</strong>. Please enter the code in the fields shown.`,
			translationParams: [sendCodeTo],
		};
	}

	return {
		translationKey: `An ${messageType} with a 6-digit code was sent to {0}. Please enter the code in the fields shown. If you did not receive a verification code, you may need to <a href="{1}">register</a>.`,
		translationParams: [sendCodeTo, registerLink],
	};
}
